document.addEventListener('DOMContentLoaded', () => {
    const filters = document.querySelectorAll('.filters li');
    const cards = document.querySelectorAll('.cell.vacancy');

    const applyFilter = (selected) => {
        // Show/hide cards
        cards.forEach(card => {
            card.classList.toggle('is-hidden', selected && card.dataset.filter !== selected);
        });

        // Update active UI
        filters.forEach(li => {
            li.classList.toggle('active', li.dataset.filter === selected);
        });
    };

    filters.forEach(li => {
        li.addEventListener('click', () => {
            const selected = li.dataset.filter;

            // Update URL
            const url = new URL(window.location);
            if (selected === '') {
                url.searchParams.delete('filter');
            } else {
                url.searchParams.set('filter', selected);
            }
            history.pushState(null, '', url);

            applyFilter(selected);
        });
    });

    // On load
    const initial = new URLSearchParams(window.location.search).get('filter') || '';
    applyFilter(initial);
});
